import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

/**
 * Firebase configuration object.
 * Uses environment variables if available, otherwise falls back to default values.
 */
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDpiBKRC48l2Qjl-7iRETQNQnSPdHg7FZc",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "jg-website-7c1e9.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "jg-website-7c1e9",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "jg-website-7c1e9.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "570168410550",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:570168410550:web:3d30de73545220cdabc117"
};

// Firebase is configured if we have a valid API key (either from env or fallback)
export const isFirebaseConfigured = true;  
export const firebaseProjectId = firebaseConfig.projectId;
export const functionsRegion = process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || 'us-central1';

let app = null;
let auth = null;
let db = null;
let functions = null;
let storage = null;

// Initialize Firebase
try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    functions = getFunctions(app, functionsRegion);
    storage = getStorage(app);
} catch (error) {
    console.error('Firebase initialization error:', error);
}

export { auth, db, functions, storage };  
export default app;